var R={ENTER:"Enter",SPACE:" ",ESCAPE:"Escape",DOWN_ARROW:40,UP_ARROW:38,LEFT_ARROW:"ArrowLeft",RIGHT_ARROW:"ArrowRight"},E=["Esc","Escape"];export{E as ESCAPE_KEYS,R as keyCodes};
